import { connect } from 'react-redux';
import { publishComment, editorChanged, focusDone } from './actionCreators';
import { isBusy, getPublishResult, getErrorMsg, getFocus } from './selectors';
import { getIsLoggedIn, getCurrentUser } from '../publicSession/selectors';
import { saveEditorDraft, removeEditorDraft, } from '../DaEditorWrapper/redux/actionCreators';
import { getEditorDraft } from '../DaEditorWrapper/redux/selectors';
import { getSiteHeaderState } from '../SiteHeader/redux/selectors';
import { flagEnabled } from '../redux/flags/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    isBusy: isBusy(state, ownProps.id),
    publishResult: getPublishResult(state, ownProps.id),
    errorMsg: getErrorMsg(state, ownProps.id),
    focus: getFocus(state, ownProps.id, ownProps.autoFocus),
    isLoggedIn: getIsLoggedIn(state),
    isLoggingOut: getSiteHeaderState(state).isLoggingOut,
    user: ownProps.user || getCurrentUser(state),
    debug: flagEnabled(state, 'eclipse_debug'),
    draftState: getEditorDraft(state, ownProps.id),
}); };
var mapDispatchToProps = {
    onPublishComment: publishComment,
    onEditorChanged: editorChanged,
    focusDone: focusDone,
    saveEditorDraft: saveEditorDraft,
    removeEditorDraft: removeEditorDraft,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CommentBox.container.js.map